export default {
  // 颜色
  colorData: [{
    id:'1', //医疗
    color:'#12bc61',
    bgColor:'#f0faf2'
  },
  {
    id:'2', // 电商
    color:'#ff9c00',
    bgColor:'#fef5e8'
  },
  {
    id:'3', // 在线教育
    color:'#495aec',
    bgColor:'#ebeff5'
  }
  ],
  menuList:[{
    id:'0', 
    name:'项目概况',
    icon:'iconSurvey'
  },
  {
    id:'1', 
    name:'成果展示',
    icon:'iconFruit'
  },
  {
    id:'13', 
    name:'学员作品',
    icon:'iconFruit'
  },
  {
    id:'12', 
    name:'所用软件',
    icon:'iconAll'
  },
  {
    id:'2', 
    name:'演示地址',
    icon:'iconLink'
  },
  {
    id:'3', 
    name:'基本信息',
    icon:'iconBase'
  },
  {
    id:'4', 
    name:'技术亮点',
    icon:'iconHighlights'
  },
  {
    id:'5', 
    name:'测试框架图',
    icon:'iconTest'
  },
  {
    id:'6', 
    name:'技术解决方案',
    icon:'iconSolution'
  },
  {
    id:'7', 
    name:'功能架构图',
    icon:'iconFunctional'
  },
  {
    id:'8', 
    name:'技术架构图',
    icon:'iconTechnical'
  },
  {
    id:'9', 
    name:'产品架构图',
    icon:'iconArchitecture'
  },
  {
    id:'10', 
    name:'产品结构图',
    icon:'iconStructure'
  },
  {
    id:'11', 
    name:'课程大纲',
    icon:'iconCourse'
  }
]
}
